module.exports = __webpack_public_path__ + "static/favicon-d6e85ac08dfb909183e59d9dadcea538.png";